import { Component, OnInit } from '@angular/core';
import { Utils } from '../common/utils';
import { HttpUtils } from '../common/http-utils';
import { LoaderService } from '../common/loader-service';
import { Toast } from '../common/toast';
import { Constants } from '../common/constants';
import { ActivatedRoute, Params } from '@angular/router';
import { LocalStorage } from '../common/local-storage';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-select-payment',
  templateUrl: './select-payment.component.html',
  styleUrls: ['./select-payment.component.css']
})



export class SelectPaymentComponent implements OnInit {

  gatewayDetailsList: any = [
    {
      "id": "PG003",
      "gatewayName": "HYDROGENPAY",
      "paymentMethod": "PAYMENT_GATEWAY",
      "currencyCode": "USD",
      "transactionFee": 6,
      "serviceCharge": 0,
      "isPctCharge": 1,
      "sequence": 1,
      "status": 1,
      "createdOn": null,
      "createdBy": null,
      "modifiedOn": null,
      "modifiedBy": null,
      "applicableFrom": 1617145200000,
      "applicationType": "APPLICATION_PAYMENT",
      "isSubmitReq": 1
    },
    {
      "id": "PG004",
      "gatewayName": "PAYSTACK",
      "paymentMethod": "PAYMENT_GATEWAY",
      "currencyCode": "USD",
      "transactionFee": 6,
      "serviceCharge": 0,
      "isPctCharge": 1,
      "sequence": 1,
      "status": 1,
      "createdOn": null,
      "createdBy": null,
      "modifiedOn": null,
      "modifiedBy": null,
      "applicableFrom": 1617145200000,
      "applicationType": "APPLICATION_PAYMENT",
      "isSubmitReq": 1
    }
  ];

  paymentFormObject: any = {};
  applicantId: string = this.constants.BLANK;
  private encryptedApplicantId: string = this.constants.BLANK;

  selectedPaymentMode: string = this.constants.BLANK
  termsAccepted: boolean = false;
  refundPolicyUrl: string = environment.refundPolicyUrl;
  private loggedUserId: string = this.constants.BLANK;

  constructor(public utils: Utils, private httpUtils: HttpUtils, private loaderService: LoaderService, private toast: Toast, public constants: Constants, private activatedRoute: ActivatedRoute, private localStorage: LocalStorage) {
    activatedRoute.params.subscribe((params: Params) => {
      this.encryptedApplicantId = params['applicantId'];
    }

    );
    this.applicantId = this.utils.decryptString(this.encryptedApplicantId)
    this.loggedUserId = this.localStorage.getLoggedUserId();


  }

  ngOnInit(): void {
  }



  trackByGateway(index: number, gateway: any): string {
    return gateway.id || index;
  }

  onPaymentMethodChange(gateway: any): void {

    if (gateway) {
      this.selectedPaymentMode = gateway.gatewayName
    }

  }
  getGatewayImage(gatewayName: string): string {
    const images = {
      'HYDROGENPAY': 'assets/images/hydrogenpay-logo.png',
      'PAYSTACK': 'assets/images/paystack-logo.png',
      'PAYFIXY': 'assets/images/payfixy.svg',
      'PAYFIXY RAVE': 'assets/images/payfixy.svg'
    };

    return images[gatewayName.toUpperCase()] || 'assets/images/default-gateway-logo.png';
  }


  private getAllPaymentGate() {
    this.loaderService.startLoader();

    this.httpUtils.fetchAllPaymentGateway().then(serverResponse => {
      this.gatewayDetailsList = serverResponse.paymentGateway;
      this.loaderService.stopLoader();

    });
  }

  async makePayment(): Promise<void> {
    this.loaderService.startLoader();

    try {

      const payload = {
        loggedUserId: this.loggedUserId,
        applicationsList: [
          this.applicantId
        ],
        paymentGateway: this.selectedPaymentMode
      }


      this.httpUtils.makeApplicationPayment(payload).then(serverResponse => {

        const paymentUrl = serverResponse?.redirectUrl;
        if (paymentUrl) {
          window.location.href = serverResponse?.redirectUrl
        } else {
          this.toast.showErrorToast("Payment failed, Please try again later");
        }

        this.loaderService.stopLoader();

      });


    } catch (error) {
      let errorMessage = 'Payment failed, Please try again later';
      this.toast.showErrorToast(errorMessage);
    } finally {
      this.loaderService.stopLoader();
    }
  }


}
